// Definindo os enums como objetos
export const Priority = {
  HIGH: 'HIGH',
  MEDIUM: 'MEDIUM',
  LOW: 'LOW',
};

export const Subject = {
  MATH: 'MATH',
  PORTUGUESE: 'PORTUGUESE',
  PHYSICS: 'PHYSICS',
  CHEMISTRY: 'CHEMISTRY',
  HISTORY: 'HISTORY',
  GEOGRAPHY: 'GEOGRAPHY',
  BIOLOGY: 'BIOLOGY',
  SOCIOLOGY: 'SOCIOLOGY',
  PHILOSOPHY: 'PHILOSOPHY',
  WRITING: 'WRITING',
};

export const KnowledgeArea = {
  HUMAN_SCIENCES: 'HUMAN_SCIENCES',
  NATURAL_SCIENCES: 'NATURAL_SCIENCES',
  MATHEMATICS: 'MATHEMATICS',
  LANGUAGES: 'LANGUAGES',
};

export const StudyIntensity = {
  CAUTIOUS: 'CAUTIOUS',
  MODERATE: 'MODERATE',
  INTENSE: 'INTENSE',
};

export const StudyStrategy = {
  COVER_ALL: 'COVER_ALL',
  PRIORITIZE_HIGH: 'PRIORITIZE_HIGH',
};

// Tipos para uso em componentes
export const Topic = {
  id: String,
  name: String,
  description: String,
  completed: Boolean,
};

export const SubjectCategory = {
  subject: String,
  categoryName: String,
  priority: String,
  topics: Array,
};

export const WeeklySchedule = {
  weekNumber: Number,
  topics: Array,
};

export const UserPreferences = {
  examDate: String,
  weeksAvailable: Number,
  intensity: String,
  strategy: String,
  hasStarted: Boolean,
};